<template>
	<div class="pb-4 border-b last:border-b-0 last:pb-0 mb-4">
		<div class="flex w-full justify-center my-6 space-x-4">
			<div class="flex flex-col justify-center">
				<img :src="certificateImg" class="max-w-[100px] rounded-lg" />
			</div>
			<div class="w-full">
				<div class="flex w-full px-2">
					<div class="text-ihh-midnight-gray w-full max-w-52 mr-4">
						<div class="font-semibold text-base space-x-1">
							<span>{{ certificate.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
							<span>Gift Certificate</span>
						</div>
					</div>
					<div class="text-rum-500 text-sm">
						{{ certificate.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
					</div>
				</div>
				<div class="text-ihh-midnight-gray font-semibold pt-2 px-2 text-xs">
					<div class="flex flex-col">
						<span>Recipient:</span>
						<span class="text-ihh-gray font-normal">{{ certificate.recipient.email }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="flex w-full justify-between text-sm text-ihh-midnight-gray">
			<div class="flex w-28 justify-around max-w-[100px]">
				<button
					@click="emitReduceQty"
					class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl bg-white items-center justify-center"
				>
					-
				</button>
				<div class="m-auto text-sm">{{ certificate.quantity }}</div>
				<button
					@click="emitIncreaseQty"
					class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl bg-white items-center justify-center"
				>
					+
				</button>
			</div>
			<div>
				<button @click="emitRemoveCert" class="underline text-xs hover:text-ihh-dark-salmon group">Remove</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CartCertificate',
	props: {
		certificate: {
			type: Object,
			required: true,
			validator: (cert) => 'amount' in cert && 'quantity' in cert && 'recipient' in cert,
		},
		index: {
			type: Number,
			required: true,
		},
		certificateImg: {
			type: String,
			required: true,
		},
	},
	methods: {
		emitReduceQty() {
			this.$emit('reduce-qty', this.index)
		},
		emitIncreaseQty() {
			this.$emit('increase-qty', this.index)
		},
		emitRemoveCert() {
			this.$emit('remove-cert', this.index)
		},
	},
}
</script>
